let params = {};
class library {
    // 初始化
    constructor(paramsData = false) {
        if (paramsData) {
            params = Object.assign({}, params, paramsData);
        }
    }
    doGetDomLocalizationData() {
        let localizationData = [];
        let localizationJsonData = [];
        $('.wdshop-lang-list .wdshop-lang-item a').each(function () {
            const country = $(this).data('value') || 'US';
            const name = $(this).data('name') || 'United States';
            localizationData.push(country);
            localizationJsonData.push({country:country, name:name});
        });
        return {data:localizationData, json:localizationJsonData};
    }
    // Update the localization
    updateLocalization({country = 'US', language = false}) {
        const formId = crypto.randomUUID();
        let formHtml;
        if(language){
            formHtml = `
                <form id="${formId}" action="/localization" method="POST" hidden>
                <input name="_method" value="PUT" />
                <input name="country_code" value="${country}" />
                <input name="language_code" value="${language}" />
                </form>
            `;
        }else{
            formHtml = `
                <form id="${formId}" action="/localization" method="POST" hidden>
                <input name="_method" value="PUT" />
                <input name="country_code" value="${country}" />
                </form>
            `;
        }
        document.body.insertAdjacentHTML("beforeend", formHtml);
        document.getElementById(formId).submit();
    }
    // Submit Form Data
    doSubmitFormData(dom = false, event = false) {
        const form = dom.data('form');
        const lovetoy = dom.data('lovetoy');
        const formId = dom.data('form-id');
        const formDom = dom.parents('#shopify-form-' + formId);
        const formData = formDom.serializeArray();
        let name = false, tips = false, email = false, submit = false, tipsDom = false, required = false;
        for (let index = 0; index < formData.length; index++) {
            const element = formData[index];
            const inputDom = $("input[name='" + element.name + "']");
            const inputFDom = inputDom.parent('.wdshop-form-item');
            name = inputFDom.data('name') || '';
            required = inputFDom.data('required') ?? false;
            tipsDom = inputFDom.find('#wdshop-newsletter-' + formId + '-tips-' + name);
            if (element.name == 'contact[email]') {
                email = element.value || inputDom.val();
            }
            if (element.value == '' && required) {
                tips = inputFDom.data(name + '-empty') || false;
                break;
            }
            if (name == 'email' && element.value != '' && required) {
                const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (pattern.test(element.value)) {
                } else {
                    tips = inputFDom.data(name + '-error') || false;
                    break;
                }
            }
        }
        if (!name && !tips) {
            switch (form) {
                case 'newsletter':
                    if (lovetoy) {
                        // send data to lovetoy api
                    }
                    break;
                default:
                    break;
            }
            submit = true;
        } else {
            if (tipsDom) {
                tipsDom.empty().html(tips).show();
                setTimeout(function () {
                    tipsDom.hide();
                }, 3000); // 3s
            }
        }
        if (submit) {
            formDom.submit();
        }
    }
    // sidebar animate
    doSidebarAnimate() {
        const pageActive = 'wdshop-page-main-animate';
        const sideActive = 'wdshop-sidebar-main-animate';
        if ($("body").hasClass(pageActive)) {
            $("body").removeClass(pageActive);
            $('.wdshop-header-icon-close').hide();
            $('.wdshop-header-icon-menu').show();
        } else {
            $("body").addClass(pageActive);
            $('.wdshop-header-icon-menu').hide();
            $('.wdshop-header-icon-close').show();
        }
        if ($('.wdshop-menu-pageslide').hasClass(sideActive)) {
            $('.wdshop-menu-pageslide').removeClass(sideActive);
        } else {
            $('.wdshop-menu-pageslide').addClass(sideActive);
        }
    }
    // sidebar menu
    doSiteSidebar() {
        const that = this;
        $(".wdshop-header-icon-menu, .wdshop-header-icon-close, .wdshop-sidebar-icon-close").bind("click", function () {
            that.doSidebarAnimate();
        });
        $('.wdshop-sidebar-menu-h3').each(function () {
            $(this).bind("click", function () {
                const fDom = $(this).parent('.wdshop-sidebar-menu-item');
                const firstDictionary = $(this).data('dictionary');
                const firstDom = fDom.find('.wdshop-sidebar-menu-second-list');
                const itemActive = 'wdshop-sidebar-menu-active';
                const firstItemActive = 'wdshop-sidebar-menu-h3-active';
                if (firstDictionary) {
                    if (fDom.hasClass(itemActive)) {
                        fDom.removeClass(itemActive);
                    } else {
                        fDom.addClass(itemActive);
                    }
                    if ($(this).hasClass(firstItemActive)) {
                        $(this).removeClass(firstItemActive);
                        firstDom.slideUp();
                    } else {
                        $(this).addClass(firstItemActive);
                        firstDom.slideDown();
                    }
                }
            });
        });
        $('.wdshop-sidebar-menu-h4').each(function () {
            $(this).bind("click", function () {
                const fDom = $(this).parent('.wdshop-sidebar-menu-second-item');
                const firstDictionary = $(this).data('dictionary');
                const firstDom = fDom.find('.wdshop-sidebar-menu-last-list');
                const itemActive = 'wdshop-sidebar-menu-second-active';
                const firstItemActive = 'wdshop-sidebar-menu-h4-active';
                if (firstDictionary) {
                    if (fDom.hasClass(itemActive)) {
                        fDom.removeClass(itemActive);
                    } else {
                        fDom.addClass(itemActive);
                    }
                    if ($(this).hasClass(firstItemActive)) {
                        $(this).removeClass(firstItemActive);
                        firstDom.slideUp();
                    } else {
                        $(this).addClass(firstItemActive);
                        firstDom.slideDown();
                    }
                }
            });
        });
    }
    // search input check
    doSearchInputCheck(dom) {
        let val = dom.val() || '';
        // console.log(dom, val)
        if (val !== '') {
            $('.wdshop-header-search-body').addClass('wdshop-active');
        } else {
            $('.wdshop-header-search-body').removeClass('wdshop-active');
            $('.wdshop-header-search-list').each(function () {
                $(this).hide();
            });
        }
    }
    // search
    async doSearch(dom = false, type = 'product', back = false) {
        const that = this;
        let search_val = $('.wdshop-header-search-input').val() || '';
        if (search_val == '') {
            return { code: 1, msg: 'Search value is empty' };
        }
        let isNumeric = /^\d+$/.test(search_val);
        let searchInput = document.querySelectorAll('input[name=q]');
        if (isNumeric && search_val.toString().length > 2) {
            search_val = 'LV' + search_val;
            searchInput.forEach(function (dom) {
                dom.value = search_val;
            });
        }
        const data = {
            q: search_val,
            resources: {
                type: type,
                limit: 4,
                options: {
                    fields: 'variants.sku,tag,title,product_type,variants.title,vendor',
                }
            }
        }
        const res = await that.doShopifyPredictiverSearch(data, false);
        if (back) {
            return res;
        }
        switch (type) {
            case 'product':
                that.doSetProductSearchData(res.data.products || [], dom);
                $('.wdshop-header-search-result-val').each(function () {
                    $(this).empty().html(search_val);
                });
                $('.wdshop-header-search-result-icon').each(function () {
                    $(this).removeAttr('data-url').attr('data-url', '/search?q=' + search_val + '&options[prefix]=last');
                });
                break;
            default:
                return res;
                break;
        }
    }
    doSetProductSearchData(data = [], dom = false) {
        const that = this;
        let html = '';
        const domName = 'wdshop-header-search-list-body';
        const domShowName = 'wdshop-header-search-list';
        data.forEach(function (item, index) {
            const mediaUrl = item.featured_image?.url || '';
            const mediaAlt = item.featured_image?.alt || '';
            const url = item.url || 'javascript:void(0);';
            html += '<li class="wdshop-space-border wdshop-alignment wdshop-header-search-list-item wdshop-clearfix">';
            html += '<div class="wdshop-hidden wdshop-space-border wdshop-space-mr-15 wdshop-border-e5 wdshop-header-search-list-item-img wdshop-clearfix">';
            html += '<a href="' + url + '" title="' + item.title + '">';
            html += '<img src="' + mediaUrl + '" alt="' + mediaAlt + '" width="50" height="50" />';
            html += '</a>';
            html += '</div>';
            html += '<div class="wdshop-header-search-list-item-info wdshop-clearfix">';
            html += '<div class="wdshop-header-search-list-item-t wdshop-header-search-list-item-title wdshop-clearfix">';
            html += '<a href="' + url + '" title="' + item.title + '">';
            html += item.title;
            html += '</a>';
            html += '</div>';
            html += '</div>';
            html += '</li>';
        });
        if (that.doCheckDomClass(domName)) {
            $('.' + domName).each(function () {
                $(this).empty().html(html);
            });
        }
        if (dom) {
            dom.show();
        } else {
            if (that.doCheckDomClass(domShowName)) {
                $('.' + domShowName).show();
            }
        }
    }
    // renew shopify cart count
    doRenewShopifyCartCount(count = 0) {
        const that = this;
        if (that.doCheckDomClass('wdshop-cart-count-now')) {
            $('.wdshop-cart-count-now').each(function () {
                $(this).empty().html(count);
            });
        } else {
            if (that.doCheckDomClass('wdshop-header-icon-cart')) {
                const header_cart_html = '<div class="wdshop-absolute wdshop-radius-9 wdshop-alignment wdshop-justify-center wdshop-header-cart-count wdshop-cart-count-now">' + count + '</div>';
                $('.wdshop-header-icon-cart').append(header_cart_html);
            }
        }
    }
    // add to cart
    async doProductAddToCart(itemsData = [], paramsData = false) {
        const that = this;
        const formData = { items: itemsData };
        const checkout = paramsData.checkout ?? false;
        const display = paramsData.display ?? false;
        const addData = await that.doShopifyAddToCart(formData);
        if (addData.code == 0) {
            if (checkout) {
                that.doCheckout();
            }
            const cartData = await that.doGetShopifyCartData();
            if (cartData.code == 0) {
                that.doRenewShopifyCartCount(cartData.data?.item_count || 0);
            }
            if (cartData.code == 0 && display) {
                that.doDisplayCart(cartData.data || []);
            }
        }
    }
    // shopify search product for handle
    async doShopifyProductForHandle(handle = false) {
        if (!handle || handle == '') {
            return { code: 1, msg: 'Product handle is error' };
        };
        const url = window.Shopify.routes.root + "products/" + handle + ".js";
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                }
                return response.json();
            }).then(data => {
                resolve({ code: 0, msg: 'success', data: data });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // shopify product recommendations
    async doShopifyProductRecommendations(paramsData = false) {
        const product_id = paramsData.product_id || false;
        let limit = paramsData.limit || 10;
        if (parseInt(limit) > 10) {
            limit = 10;
        }
        const intent = paramsData.intent || 'related'; // related  complementary
        if (!product_id || product_id == '') {
            return { code: 1, msg: 'Product Id is error' };
        };
        const url = window.Shopify.routes.root + "recommendations/products.json?product_id=" + product_id + "&intent=" + intent;
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                }
                return response.json();
            }).then(data => {
                resolve({ code: 0, msg: 'success', data: data });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // shopify predictive search
    async doShopifyPredictiverSearch(paramsData = false, format = true) {
        const that = this;
        if (!paramsData) {
            return { code: 1, msg: 'Params is empty' };
        };
        const query_string = that.doObjectToQueryString(paramsData, format);
        const url = window.Shopify.routes.root + "search/suggest.json?" + query_string;
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                }
                return response.json();
            }).then(data => {
                const queries = data.resources?.results?.queries || [];
                const products = data.resources?.results?.products || [];
                const collections = data.resources?.results?.collections || [];
                const pages = data.resources?.results?.pages || [];
                const articles = data.resources?.results?.articles || [];
                resolve({
                    code: 0, msg: 'success', data: {
                        queries: queries,
                        products: products,
                        collections: collections,
                        pages: pages,
                        articles: articles,
                    }
                });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // Object To QueryString
    doObjectToQueryString(params = false, format = true) {
        if (!params) {
            return '';
        };
        if (format) {
            return JSON.stringify(params);
        };
        return $.param(params);
    }
    // add data to shopify cart
    async doShopifyAddToCart(formData, format = true) {
        if (format) {
            formData = JSON.stringify(formData);
        }
        return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: formData,
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                } else {
                    resolve({ code: 0, msg: 'success', data: response.json() });
                }
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // update data to shopify cart
    async doShopifyCartUpdate(formData, format = true) {
        if (format) {
            formData = JSON.stringify(formData);
        }
        return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: formData,
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                } else {
                    resolve({ code: 0, msg: 'success', data: response.json() });
                }
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // change shopify cart
    async doShopifyCartChange(formData, format = true) {
        if (format) {
            formData = JSON.stringify(formData);
        }
        return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + "cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: formData,
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                } else {
                    resolve({ code: 0, msg: 'success', data: response.json() });
                }
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // clear shopify cart
    async doShopifyCartClear() {
        return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + "cart/clear.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                } else {
                    resolve({ code: 0, msg: 'success', data: response.json() });
                }
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // get shopify cart data
    async doGetShopifyCartData() {
        return new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + "cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                }
                return response.json();
            }).then(data => {
                resolve({ code: 0, msg: 'success', data: data });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // get shopify product data
    async doGetShopifyProductData(handle = false) {
        return new Promise((resolve, reject) => {
            if (!handle) {
                reject({ code: 1, msg: 'Handle error' });
            }
            const url = 'products/' + handle + '.js';
            fetch(window.Shopify.routes.root + url)
                .then(response => {
                    if (!response.ok) {
                        const errorData = {
                            status: response.status ?? 0,
                            message: response.message || '',
                            description: response.description || '',
                        };
                        reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                    }
                    return response.json();
                }).then(data => {
                    resolve({ code: 0, msg: 'success', data: data });
                }).catch((error) => {
                    reject({ code: 1, msg: error });
                });
        });
    }
    // get shopify localization data
    async doGetShopifyLocalizationData(paramsData = false) {
        const country = paramsData.country || false;
        const language = paramsData.language || false;
        let url = window.Shopify.routes.root + "browsing_context_suggestions.json";
        if(country){
            url += '?country[enabled]=true';
            url += `&country[exclude]=${window.Shopify.country}`;
        }
        if(language){
            if(country){
                url += '&language[enabled]=true';
            }else{
                url += '?language[enabled]=true';
            }
            url += `&language[exclude]=${window.Shopify.language}`;
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((response) => {
                if (!response.ok) {
                    const errorData = {
                        status: response.status ?? 0,
                        message: response.message || '',
                        description: response.description || '',
                    };
                    reject({ code: 1, msg: 'Network response was not ok', data: errorData });
                }
                return response.json();
            }).then(data => {
                resolve({ code: 0, msg: 'success', data: data });
            }).catch((error) => {
                reject({ code: 1, msg: error });
            });
        });
    }
    // display cart
    doDisplayCart(data = false) {
        const that = this;
        const list = data.items;
        const count = data.item_count;
        const format = that.doGetShopCurrency({ money_format: $('.wdshop-cart-wrap').data('money-format') || '${{amount}}' });
        const showName = 'wdshop-cart-show';
        const bgName = 'wdshop-cart-cart-bg';
        const cartName = 'wdshop-cart-wrap';
        const cartBoxName = 'wdshop-cart-list-body';
        const remove = $("." + cartBoxName).data('remove') ?? false;
        var html = '';
        list.forEach(function (item, index) {
            const original_line_price = item.original_line_price / 100;
            const featured_image = item.featured_image?.url || item.image;
            const featured_image_alt = item.featured_image?.alt || item.title;
            html += '<li class="wdshop-cart-list-item">';
            html += '<a href="' + item.url + '" title="' + item.image.alt + '">';
            html += '<div class="wdshop-cart-item-image">';
            html += '<img src="' + featured_image + '&width=300" class="wdshop-img wdshop-cart-item-image-img" alt="' + featured_image_alt + '" loading="lazy" width="120" height="120" />';
            html += '</div>';
            html += '</a>';
            html += '<div class="wdshop-cart-item-product-info">';
            html += '<a href="' + item.url + '" title="' + item.title + '">';
            html += '<div class="wdshop-cart-product-name">' + item.title + '</div>';
            html += '</a>';
            html += '<div class="wdshop-cart-product-options">Quantity: ' + item.quantity + '</div>';
            html += '<div class="wdshop-cart-product-price">' + format + original_line_price + '</div>';
            html += '</div>';
            if (remove) {
                html += '<div class="wdshop-space-ml-15 wdshop-alignment wdshop-cart-item-product-remove">';
                html += '<a href="javascript:void(0);" onclick="doRemoveShopifyCartItem(' + (parseInt(index) + 1) + ')">';
                html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" style="width:15px;" class="wdshop-icon-s-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg>';
                html += '</a>';
                html += '</div>';
            }
            html += '</li>';
        });
        $("." + cartBoxName).empty().html(html);
        $("." + bgName).addClass(showName);
        $("." + cartName).addClass(showName);
        that.doRenewShopifyCartCount(count);
    }
    // jump to checkout
    doCheckout() {
        window.location.href = "/checkout";
    }
    // get buy data
    doGetProductDetailsBuyData(div = false) {
        if (!div) {
            return false;
        }
        let that = this;
        const dom = div.parent('.wdshop-product-details-button-body');
        const variantId = dom.data('id');
        let quantity = 1;
        if (that.doCheckDomClass('wdshop-product-quantity-number')) {
            quantity = $('.wdshop-product-quantity-number').val();
        }
        const itemData = { id: variantId, quantity: quantity };
        const data = [itemData];
        return data;
    }
    // dom count
    doDomCount(dom = false) {
        if (!dom) {
            return 0;
        }
        return dom.length;
    }
    // is warp
    doIsWarp() {
        let that = this;
        const pageWidth = $(window).width();
        const isWarp = pageWidth <= 767;
        return isWarp;
    }
    // page size
    doGetPageSize() {
        const pageWidth = $(window).width();
        const pageHeight = $(window).height();
        return {width:pageWidth, height:pageHeight};
    }
    // recommendations init
    async doShopifyRecommendations() {
        return new Promise((resolve, reject) => {
            let url, limit;
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(productRecommendationsSection);
                url = productRecommendationsSection.dataset.url;
                limit = productRecommendationsSection.dataset.limit;
                fetch(url)
                    .then((response) => response.text())
                    .then((text) => {
                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const recommendations = html.querySelector('.wdshop-product-like-wrap');
                        if (recommendations && recommendations.innerHTML.trim().length) {
                            productRecommendationsSection.innerHTML = recommendations.innerHTML;
                        }
                        resolve({ code: 0, msg: 'success', data: { url: url, limit: parseInt(limit) } });
                    })
                    .catch((e) => {
                        reject({ code: 1, msg: e });
                    })
            }
            const productRecommendationsSection = document.querySelector('.wdshop-product-like-wrap');
            const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
            observer.observe(productRecommendationsSection);
        });
    }
    // swiper init
    doSwiperInit(params = false) {
        const dom = params.dom ?? false;
        if (!dom) {
            return false;
        }
        const width = params.width ?? false;
        const spaceBetween = params.spaceBetween ?? 0;
        const direction = params.direction ?? false;
        const loop = params.loop ?? false;
        const slidesPerView = params.slidesPerView ?? 1;
        const mousewheel = params.mousewheel ?? false;
        const freeMode = params.freeMode ?? false;
        const watchSlidesProgress = params.watchSlidesProgress ?? false;
        const navigation = params.navigation ?? false;
        const pagination = params.pagination ?? false;
        const thumbs = params.thumbs ?? false;
        const breakpoints = params.breakpoints ?? false;
        const autoHeight = params.autoHeight ?? false;
        const autoplay = params.autoplay ?? false;
        const centeredSlides = params.centeredSlides ?? false;
        const config = {
            loop: loop,
            slidesPerView: slidesPerView,
            mousewheel: mousewheel,
        }
        if (width) {
            config.width = width;
        }
        if (spaceBetween) {
            config.spaceBetween = spaceBetween;
        }
        if (direction) {
            config.direction = direction;
        }
        if (freeMode) {
            config.freeMode = freeMode;
        }
        if (watchSlidesProgress) {
            config.watchSlidesProgress = watchSlidesProgress;
        }
        if (navigation) {
            config.navigation = navigation;
        }
        if (pagination) {
            config.pagination = pagination;
        }
        if (thumbs) {
            config.thumbs = thumbs;
        }
        if (breakpoints) {
            config.breakpoints = breakpoints;
        }
        if (autoplay) {
            config.autoplay = autoplay;
        }
        if (autoHeight) {
            config.autoHeight = autoHeight;
        }
        if (centeredSlides) {
            config.centeredSlides = centeredSlides;
        }
        return new Swiper(dom, config);
    }
    // click to expand
    doClickToExpand(paramsData = false) {
        const active = paramsData.active || false;
        const item = paramsData.item || false;
        const show = paramsData.show || false;
        const parent = paramsData.parent || false;
        const itemClass = '.' + item;
        const showClass = '.' + show;
        const parentClass = '.' + parent;
        const itemDiv = $(itemClass);
        const bodyDiv = $(showClass);
        if ($(window).width() > 767) {
            // pc
            bodyDiv.each(function (index) {
                const that = $(this);
                that.slideDown();
            });
        } else {
            // wap
            bodyDiv.each(function (index) {
                const that = $(this);
                if (index === bodyDiv.length - 1) {
                } else {
                    that.slideUp();
                }
            });
            itemDiv.each(function (index) {
                const that = $(this);
                const itemBodyDiv = that.parent(parentClass).find(showClass);
                that.bind("click", function () {
                    if (that.hasClass(active)) {
                        that.removeClass(active);
                        itemBodyDiv.slideUp();
                    } else {
                        that.addClass(active);
                        itemBodyDiv.slideDown();
                    }
                });
            });
        }
    }
    // scroll to header
    doScrollHeader(id = false) {
        if (!id) {
            return false;
        }
        const page_height = $(window).height();
        const scrolltop = $(id)
        $(window).scroll(function () {
            if ($(window).scrollTop() > page_height) {
                scrolltop.fadeIn(500);
            } else {
                scrolltop.fadeOut(500);
            }
        });
        scrolltop.click(function () {
            $("html, body").animate({ scrollTop: 0 }, 500);
        });
    }
    // get shop currency
    doGetShopCurrency(paramsData = false) {
        const money_format = paramsData.money_format || '${{amount}}';
        const format = money_format.replace("{{amount}}", "");
        return format;
    }
    // calculate discount
    doCalculateDiscount(paramsData = false) {
        const that = this;
        const price = paramsData.price || '$0';
        const compare_at_price = paramsData.compare_at_price || '$0';
        const format = that.doGetShopCurrency(paramsData);
        const priceNum = price.replace(format, "");
        const compareNum = compare_at_price.replace(format, "");
        let save = '0.00';
        let discount = 0;
        let discount_text = '0%';
        if (that.doDecimalCompare(compareNum, priceNum, 'gt')) {
            save = that.doDecimalCalculate(compareNum, priceNum, 'minus', 2, false);
            discount = that.doDecimalCalculate(save, compareNum, 'div');
            discount_text = '-' + that.doDecimalCalculate(discount, 100, 'times', 0) + '%';
        }
        const save_text = 'You save ' + format + save;
        return { save: save, save_text: save_text, discount: discount, discount_text: discount_text };
    }
    // check number
    doIsValidNumber(str) {
        return /^-?\d+(\.\d+)?$/.test(str);
    }
    // check dom class
    doCheckDomClass(dom = 'wdshop') {
        var hasClass = false;
        $('*').each(function () {
            if ($(this).hasClass(dom)) {
                hasClass = true;
                return false; // 提前退出循环
            }
        });
        return hasClass;
    }
    // set url params
    doSetUrlParameter(key, value) {
        let url = new URL(window.location);
        let searchParams = new URLSearchParams(url.search);
        searchParams.set(key, value);
        url.search = searchParams.toString();
        window.history.pushState({ path: url.href }, '', url.href);
    }
    // decimal calculate
    doDecimalCalculate(num1 = 0, num2 = 0, type = 'times', bit = 2, trim = true) {
        const a = new Big(num1);
        const b = new Big(num2);
        let calculate;
        switch (type) {
            case 'plus':
                // 加
                calculate = a.plus(b);
                break;
            case 'minus':
                // 减
                calculate = a.minus(b);
                break;
            case 'div':
                // 除
                calculate = a.div(b);
                break;
            default:
                // 乘
                calculate = a.times(b);
                break;
        }
        calculate = calculate.toFixed(bit);
        if (trim) {
            calculate = calculate.replace(/\.?0+$/, '');
        }
        return calculate;
    }
    // decimal compare
    doDecimalCompare(num1 = 0, num2 = 0, type = 'eq') {
        const a = new Big(num1);  // 10
        const b = new Big(num2);  // 20
        switch (type) {
            case 'gt':
                // 大于
                return a.gt(b);  // false，a > b
                break;
            case 'lt':
                // 小于
                return a.lt(b);  // true，a < b
                break;
            default:
                // eq等于
                return a.eq(b);  // false，a = b
                break;
        }
    }
    // Hls Play
    doHlsPlay(params = false) {
        const dom = params.dom || false;
        const url = params.url || false;
        if (!dom || !url) {
            return false;
        };
        const video = document.getElementById(dom);
        if (Hls.isSupported()) {
            var hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(video);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {
                video.play();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            video.src = url;
            video.addEventListener('loadedmetadata', function () {
                video.play();
            });
        }
    }
    // Video Play
    doVideoPlay() {
        const that = this;
        $('.wdshop-product-details-media-preview-item-video-icon').each(function () {
            $(this).bind("click", function () {
                const type = $(this).data('type');
                const index = $(this).data('index');
                const url = $(this).data('url') || '';
                const format = $(this).data('format') || 'mp4';
                const vimeo = $(this).data('vimeo') || '';
                let dom = false;
                $(this).siblings().parent('.wdshop-product-details-media-preview-item').find('.product-details-video-label')[0].pause();
                switch (type) {
                    case 'custom':
                        dom = $('#product-custom-video-' + index);
                        if(url !== '' && dom && format == 'm3u8' && vimeo == ''){
                            dom.attr('controls', 'controls');
                            that.doHlsPlay({ dom: 'product-custom-video-' + index, url: url });
                            $(this).hide();
                            that.doVideoPlayEnded(dom, $(this));
                        }
                        if(url !== '' && dom && format == 'mp4' && vimeo == ''){
                            dom.attr('controls', 'controls');
                            dom.attr('src', url);
                            dom[0].play();
                            $(this).hide();
                            that.doVideoPlayEnded(dom, $(this));
                        }
                        break;
                    case 'shopify':
                        dom = $('#product-shopify-video-' + index);
                        if(url !== '' && dom && format == 'm3u8'){
                            dom.attr('controls', 'controls');
                            that.doHlsPlay({ dom: 'product-shopify-video-' + index, url: url });
                            $(this).hide();
                            that.doVideoPlayEnded(dom, $(this));
                        }
                        if(url !== '' && dom && format == 'mp4'){
                            dom.attr('controls', 'controls');
                            dom.attr('src', url);
                            dom[0].play();
                            $(this).hide();
                            that.doVideoPlayEnded(dom, $(this));
                        }
                        break;
                    default:
                        break;
                }
            });
        });
    }
    // Video Play ended
    doVideoPlayEnded(obj = false, dom = false) {
        if(!obj){
            return false;
        }
        obj.on('ended', function() {
            obj.removeAttr('controls');
            obj.removeAttr('src');
            if(dom){
                dom.show();
            }
        });
    }
    // tag link check
    doCheckTagUrl() {
        const domain = window.location.protocol + "//" + window.location.host;
        let url = window.location.href;
        url = url.replace(domain, "");
        if (url == '/collections/monster-dildo/male-sex-toy') {
            window.location.href = '/collections/monster-dildo';
        } else if (url == '/collections/best-pocket-pussy/vibrator-sex-toy?filter.v.price.gte=') {
            window.location.href = '/collections/best-pocket-pussy';
        } else if (url == '/collections/cumming-dildo/adult-toys-for-women') {
            window.location.href = '/collections/cumming-dildo';
        }
    }
}